import "../style/answer.css"

export function Answer(props) {
    const returnText = () => {
        return props.text;
    }
    
    return(
        <button id={props.prefix} className="answer" onClick={props.next}>
            <div className="prefix-frame">
                {props.prefix}
            </div>
            <span className="answer-text">
                {props.text}
            </span>
        </button>
    )
}